// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopOrderPagedListRequestModel from '../../model/get-shop-order-paged-list-request-model';
import GetShopOrderPagedListRequestDTO from '../dto/get-shop-order-paged-list-request-dto';
import dtoSchema from '../schemas/get-shop-order-paged-list-request-schema';

export default abstract class GetShopOrderPagedListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopOrderPagedListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.orderStateId = data.orderStateId;
      this.dateFrom = data.dateFrom;
      this.dateTo = data.dateTo;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  orderStateId?: number;
  /**
  * @type {date-time}
  */
  dateFrom?: string;
  /**
  * @type {date-time}
  */
  dateTo?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetShopOrderPagedListRequestDTO>): GetShopOrderPagedListRequestModel;
  static toModel(dto: DeepPartial<GetShopOrderPagedListRequestDTO> | undefined | null): GetShopOrderPagedListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopOrderPagedListRequestDTO> | undefined | null): GetShopOrderPagedListRequestModel | undefined {
    return dto ? new GetShopOrderPagedListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopOrderPagedListRequestModel> | GetShopOrderPagedListRequestModel): GetShopOrderPagedListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      orderStateId: unwrapped.orderStateId,
      dateFrom: unwrapped.dateFrom,
      dateTo: unwrapped.dateTo,
      searchCriteria: unwrapped.searchCriteria,
    } as GetShopOrderPagedListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopOrderPagedListRequestModel, can not map to GetShopOrderPagedListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
